import PropTypes from 'prop-types';

import { PaymentInfoModal, countryToggleConfig } from '@spotahome/ui-library';

import ListingContent from '../ListingContent';
import { usePricingContext } from '../../context/PricingContext';
import { landlordPoliciesContainFees } from '../../utils/landlordPolicies';

import './ListingPaymentInfoModal.scss';

const ListingPaymentInfoModal = ({
  currencyIsoCode,
  countryCode,
  landlordPolicies = '',
  hasRentCollection = false,
  hasDepositProtection = false
}) => {
  const {
    pricingDetails: { pricing },
    downPaymentTimeInterval,
    detailedAdminFee
  } = usePricingContext();

  const offer = pricing?.offer;

  const landlordPoliciesHasFees = landlordPoliciesContainFees(landlordPolicies);
  const moveLandlordPoliciesToPricing =
    countryToggleConfig(countryCode).moveLandlordPoliciesToPricing;

  const shouldRenderLandlordPolicies =
    moveLandlordPoliciesToPricing &&
    landlordPoliciesHasFees &&
    landlordPolicies;

  return (
    <PaymentInfoModal
      pricing={{
        ...pricing,
        offer,
        currencyIsoCode
      }}
      downPaymentTimeInterval={downPaymentTimeInterval}
      detailedAdminFee={detailedAdminFee}
      contractDurationType={pricing && pricing.contractDurationType}
      hideDepositElanLaw={countryToggleConfig(countryCode).hideDepositElanLaw}
      hasDepositProtection={hasDepositProtection}
      renderLandlordPolicies={
        shouldRenderLandlordPolicies
          ? () => (
              <ListingContent
                className="listing-payment-info-modal__landlord-policies"
                content={landlordPolicies}
              />
            )
          : null
      }
      hasRentCollection={hasRentCollection}
    />
  );
};

ListingPaymentInfoModal.propTypes = {
  currencyIsoCode: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  landlordPolicies: PropTypes.string,
  hasRentCollection: PropTypes.string,
  hasDepositProtection: PropTypes.bool
};

export default ListingPaymentInfoModal;
